import React from 'react';
import PropTypes from 'prop-types';

// material-ui
import withStyles from '@material-ui/core/styles/withStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogContentText from '@material-ui/core/DialogContentText';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Check';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';

// custom
import TableMethod from 'components/TableMethod';

// styles
import styles from './styles';

class FormSetting extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    fullScreen: PropTypes.bool,

    close: PropTypes.func,
    open: PropTypes.bool,

    setting: PropTypes.object,

    createSetting: PropTypes.func,
    updateSetting: PropTypes.func,
    deleteSetting: PropTypes.func,
    refresh: PropTypes.func,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      loading: false,
      type: '',
      value: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    const { open } = this.props;
    if (nextProps.open && !open) {
      this.init(nextProps.setting);
    }
  }

  handleChange = name => (event) => {
    const { target } = event;
    const { value } = target;

    this.setState({
      [name]: value,
    });
  };

  init(setting) {
    this.setState({
      loading: false,
      type: setting ? setting.type : '',
      value: setting ? setting.value : '',
    });
  }

  delete() {
    const { NotificationCenter } = this.context;
    NotificationCenter.sweetAlert(
      {
        title: 'Are you sure ?',
        subtitle: 'If you delete this setting, you won\'t be able to recover it.',
        timestamp: new Date().getTime(),
        error: true,
      },
      {
        cancel: {
          label: 'Cancel',
          level: 'default',
        },
        confirm: {
          label: 'I am sure',
          level: 'error',
          callback: this.confirmDelete.bind(this),
        },
      },
    );
  }

  async confirmDelete() {
    const {
      deleteSetting,
      close,
      refresh,
      setting,
    } = this.props;

    const { NotificationCenter } = this.context;
    close();
    const resp = await deleteSetting(setting.id);
    if (resp.success) {
      NotificationCenter.sweetAlert(
        {
          title: 'Setting has been deleted.',
          success: true,
          timestamp: new Date().getTime(),
        },
      );
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  async save() {
    const {
      updateSetting,
      createSetting,
      setting,
      refresh,
      close,
    } = this.props;

    const {
      type,
      value,
    } = this.state;

    const {
      NotificationCenter,
    } = this.context;

    let resp;
    this.setState({ loading: true });
    if (setting) {
      resp = await updateSetting(
        setting.id,
        {
          type,
          value,
        },
      );
    } else {
      resp = await createSetting({
        type,
        value,
      });
    }

    this.setState({ loading: false });

    if (resp.success) {
      NotificationCenter.sweetAlert(
        {
          title: setting ? 'Setting has been updated.' : 'Setting has been created.',
          success: true,
          timestamp: new Date().getTime(),
        },
      );

      close();
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  render() {
    const {
      classes,
      fullScreen,
      open,
      setting,
      close,
    } = this.props;

    const {
      type,
      loading,
      value,
    } = this.state;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        scroll="paper"
        onClose={close}
        aria-labelledby="responsive-dialog-title"
      >
        {
          loading
            ? (
              <div className={classes.progressContainer}>
                <DialogTitle id="alert-dialog-title">
                  Loading
                </DialogTitle>
                <CircularProgress />
              </div>
            )
            : (
              <div>
                <DialogTitle id="responsive-dialog-title">
                  {
                    setting
                      ? `${setting.type}`
                      : 'Let\'s Create a New Setting'
                  }
                </DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    {
                      setting
                        ? 'To update the setting, fill the form bellow :'
                        : 'To create a new setting, fill the form bellow :'
                    }
                  </DialogContentText>
                  <Grid container spacing={8}>
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <InputLabel htmlFor="role-simple">Type</InputLabel>
                        <Select
                          value={type}
                          onChange={this.handleChange('type')}
                          inputProps={{
                            name: 'type',
                            id: 'type-simple',
                          }}
                        >
                          <MenuItem key={'fps'} value={'fps'}>
                            Fps
                          </MenuItem>
                          <MenuItem key={'iso'} value={'iso'}>
                            Iso
                          </MenuItem>
                          <MenuItem key={'angle'} value={'angle'}>
                            Angle
                          </MenuItem>
                          <MenuItem key={'tc'} value={'tc'}>
                            Tc
                          </MenuItem>
                          <MenuItem key={'grid'} value={'grid'}>
                            Grid
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        id="value"
                        label="Value *"
                        className={classes.textField}
                        value={value}
                        onChange={this.handleChange('value')}
                      />
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions
                  className={classes.dialogActions}
                >
                  {
                    setting
                    && (
                      <Button
                        className={classes.delete}
                        onClick={this.delete.bind(this)}
                      >
                        <DeleteIcon className={classes.leftIcon} />
                        &nbsp;Delete
                      </Button>
                    )
                  }
                  <Button
                    onClick={close}
                  >
                    <CloseIcon className={classes.leftIcon} />
                    &nbsp;Close
                  </Button>
                  <Button
                    color="primary"
                    autoFocus
                    onClick={this.save.bind(this)}
                  >
                    <SaveIcon className={classes.leftIcon} />
                    &nbsp;
                    {
                      setting
                        ? 'Save'
                        : 'Create'
                    }
                  </Button>
                </DialogActions>
              </div>
            )
        }
      </Dialog>
    );
  }
}

export default withStyles(styles)(withMobileDialog()(FormSetting));
